import { render, staticRenderFns } from "./groupAwardDetail.vue?vue&type=template&id=509a0711&scoped=true"
import script from "./groupAwardDetail.vue?vue&type=script&lang=js"
export * from "./groupAwardDetail.vue?vue&type=script&lang=js"
import style0 from "./groupAwardDetail.vue?vue&type=style&index=0&id=509a0711&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a0711",
  null
  
)

export default component.exports